import React from 'react'

import Slider from './Components/Slider/Slider';

import './style.css';

import JobMaterial from './Components/Material/JobMaterial';

import ShowFullItem from './Components/Material/ShowFullItem';
import Call from './Components/CallBack/Call';
import Comment from './Components/Comment/Comment';
import Brands from './Components/Brands/Brands';
import Project from './Components/Project/Project';
import Statistic from './Components/Statistic/Statistic';
import Blog from './Components/Blog/Blog';
import ContactUs from './Components/ContactUs.jsx/ContactUs';

class Main extends React.Component {
   constructor(props) {
      super(props)
      this.state = {
         materialBlock: [
            {
               id: 1,
               title: 'Interior Design',
               img: 'Design.png',
               about: 'Enhancing the interior to achieve a healthier environment for the people using right space.',
               category: 'design'
            },
            {
               id: 2,
               title: 'Furniture',
               img: 'Furniture.png',
               about: 'Movable articles that are used to make a room or building suitable for living or working.',
               category: 'design'
            },
            {
               id: 3,
               title: 'Flooring',
               img: 'projectOne.png',
               about: 'Thin object any finished material applied over a floor structure to provide a walking surface.',
               category: 'design'
            }
         ],
         showFullItem: false,
         fullItem: {},
         comments: [
            {
               id: 1,
               foto: 'comm1.png',
               name: 'Lisa Clairton',
               country: 'New York, USA',
               comment: 'We selected Interno interior because of rigorous design background & education.'
            },
            {
               id: 2,
               foto: 'comm2.png',
               name: 'David Knight',
               country: 'Sydney, Australia',
               comment: 'The team exceeded our expectations and emerged as leaders of our project’s.'
            },
            {
               id: 3,
               foto: 'comm3.png',
               name: 'Lisa Clairton',
               country: 'Paris, France',
               comment: 'They balanced the architectural vision and the project realities beautifully.'
            }
         ],
         brands: [
            {
               id: 1,
               icons: 'brand1.png'
            },
            {
               id: 2,
               icons: 'brand2.png'
            },
            {
               id: 3,
               icons: 'brand3.png'
            },
            {
               id: 4,
               icons: 'brand4.png'
            },
            {
               id: 5,
               icons: 'brand5.png'
            }
         ],
      }
      this.onShowItem = this.onShowItem.bind(this)
   }
   render() {
      return (
         <main className='main_components'>
            <div className='swiper--slider_front'>
               <Slider />
            </div>
            <JobMaterial onShowItem={this.onShowItem} materialBlock={this.state.materialBlock} />
            {this.state.showFullItem && <ShowFullItem onShowItem={this.onShowItem} item={this.state.fullItem} />}
            <Call />
            <Comment comments={this.state.comments} />
            <Brands brands={this.state.brands} />
            <Project />
            <Statistic />
            <Blog />
            <ContactUs />
         </main>
      )
   }
   onShowItem(item) {
      this.setState({ fullItem: item })
      this.setState({ showFullItem: !this.state.showFullItem })
   }
}

export default Main;